/**
 * Free-trial details the wallet `/start` endpoints send (PAY-2341), also on the
 * public checkout session as `trial`.
 *
 * A free-trial checkout is due $0 today, so the sheet total is $0. On its own
 * that reads like a free product, so the sheet's total line carries the trial
 * instead, e.g. "3-day free trial, then 60.00 USD/month". The backend builds
 * the wording; the SDK only shows it.
 */
export type CheckoutTrialInfo = {
  days: number;
  /** First charge when the trial ends (atoms); `label` states the ongoing price. */
  first_charge_amount_atom: number;
  interval: "day" | "week" | "month" | "year";
  interval_count: number;
  label: string;
};

/** The label for the wallet sheet's total line. */
export function walletTotalLabel(trial: CheckoutTrialInfo | null | undefined): string {
  return trial?.label || "Total";
}
